import { RoutePath } from "#src/utils/route";
import { WorkflowsAllRoutePath } from "..";

export const WorkflowRoutePath = WorkflowsAllRoutePath.concat(
  new RoutePath<"workflowId">({
    path: "/:workflowId",
    title: "Workflow",
    isHidden: true,
  })
);
